import { EmployeesSelectionStep } from "../../../appointment/components/EmployeesSelectionStep/EmployeesSelectionStep";
import { IGroupClassFamilyMember } from "../../models";

interface IFamilyMemberSelectionStepProps {
  familyMembers: IGroupClassFamilyMember[];
  selectedFamilyMember: IGroupClassFamilyMember | null;
  onFamilyMemberSelect: (familyMember: IGroupClassFamilyMember) => void;
  isLoading?: boolean;
}

/**
 * Wrapper around EmployeesSelectionStep for selecting family members
 */
export const FamilyMemberSelectionStep = ({
  familyMembers,
  selectedFamilyMember,
  onFamilyMemberSelect,
  isLoading = false,
}: IFamilyMemberSelectionStepProps) => {
  // Transform family members to look like employees for the reused component
  // Mark members with existing reservations as unavailable
  const membersAsEmployees = familyMembers.map((member) => ({
    id: member.id,
    name: member.name,
    role: member.hasReservation ? "Вече има резервация за този клас" : "",
    isAvailable: !member.hasReservation,
    priceModifier: 1,
    bookedSlots: [],
  }));

  return (
    <EmployeesSelectionStep
      employees={membersAsEmployees}
      selectedEmployee={
        selectedFamilyMember
          ? {
              id: selectedFamilyMember.id,
              name: selectedFamilyMember.name,
              role: selectedFamilyMember.hasReservation ? "Вече има резервация за този клас" : "",
              isAvailable: !selectedFamilyMember.hasReservation,
              priceModifier: 1,
              bookedSlots: [],
            }
          : null
      }
      onEmployeeSelect={(employee) => {
        const selectedMember = familyMembers.find(
          (member) => member.id === employee.id,
        );
        if (selectedMember && !selectedMember.hasReservation) {
          onFamilyMemberSelect(selectedMember);
        }
      }}
      isLoading={isLoading}
      title="Изберете потребител"
      subtitle="Изберете за кого да резервирате мястото"
      loadingText="Зареждане на потребители..."
      emptyText="В момента няма налични потребители"
    />
  );
};
